document.addEventListener('DOMContentLoaded', function () {
    // Offset nav below WP admin bar
    const adminBar = document.querySelector('#wpadminbar');
    const nav = document.querySelector('#wrapper-navbar > nav');
    if (adminBar && nav) {
        nav.style.marginTop = adminBar.offsetHeight + 'px';
    }

    // Search Modal Focus
    const searchModal = document.getElementById('searchModal');
    if (searchModal) {
        searchModal.addEventListener('shown.bs.modal', function () {
            const searchInput = this.querySelector('.search-modal__input');
            if (searchInput) searchInput.focus();
        });
    }

    // Fixed Header on Scroll
    const updateFixedHeader = () => {
        const nav = document.getElementById('main-nav');
        if (window.scrollY > 50) {
            document.body.classList.add('fixed-header');
            if (nav) nav.classList.add('home-navbar--solid');
        } else {
            document.body.classList.remove('fixed-header');
            if (nav) nav.classList.remove('home-navbar--solid');
        }
    };
    window.addEventListener('scroll', updateFixedHeader, { passive: true });
    updateFixedHeader(); // Initialize on load

    /* Intersection Observer for smooth scroll reveal animations */
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.reveal-block').forEach(block => {
        observer.observe(block);
    });

    /* Counter animation for USP section */
    const counters = document.querySelectorAll('.home-usp__item .home-heading-h2');
    const counterDuration = 5000; // 5 seconds as requested

    const animateCounter = (el) => {
        const text = el.innerText;
        // Extract number only (remove spaces and non-digits)
        const target = parseInt(text.replace(/\s/g, '').replace(/[^\d]/g, ''), 10);
        if (isNaN(target)) return;

        // Extract suffix (like "+" or "m")
        const suffix = text.replace(/[0-9\s]/g, '');
        const hasSpace = text.includes(' ');

        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / counterDuration, 1);

            // Easing function for smoother "modern" feel (easeOutExpo)
            const easeOutExpo = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            const currentCount = Math.floor(easeOutExpo * target);

            // Format with spaces if original had them
            let displayCount = currentCount.toString();
            if (hasSpace) {
                displayCount = currentCount.toLocaleString('pl-PL').replace(/,/g, ' ').replace(/\u00a0/g, ' ');
            }

            el.innerText = displayCount + suffix;

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                let finalCount = target.toString();
                if (hasSpace) {
                    finalCount = target.toLocaleString('pl-PL').replace(/,/g, ' ').replace(/\u00a0/g, ' ');
                }
                el.innerText = finalCount + suffix;
            }
        };
        window.requestAnimationFrame(step);
    };

    const counterObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    counters.forEach(counter => counterObserver.observe(counter));

    // Equalize heights of course-atuty-item__header in each row dynamically
    const equalizeAtutyHeaders = () => {
        const headers = document.querySelectorAll('.course-atuty-item__header');
        if (headers.length === 0) return;

        // Reset heights to auto first to recalculate naturally
        headers.forEach(header => {
            header.style.height = 'auto';
        });

        // Stacked mobile layout doesn't need aligned heights
        if (window.innerWidth < 720) return;

        // Group headers by row based on offsetTop of their parent items
        const rows = {};
        headers.forEach(header => {
            const item = header.closest('.course-atuty-item');
            if (!item) return;
            const top = item.offsetTop;
            const rowKey = Math.round(top / 5) * 5; // allow small rounding diffs
            if (!rows[rowKey]) {
                rows[rowKey] = [];
            }
            rows[rowKey].push(header);
        });

        // Apply max height of each row's headers to all headers in that row
        Object.keys(rows).forEach(rowKey => {
            const rowHeaders = rows[rowKey];
            let maxHeight = 0;
            rowHeaders.forEach(header => {
                const height = header.offsetHeight;
                if (height > maxHeight) maxHeight = height;
            });
            rowHeaders.forEach(header => {
                header.style.height = maxHeight + 'px';
            });
        });
    };

    equalizeAtutyHeaders();
    window.addEventListener('resize', equalizeAtutyHeaders);
    window.addEventListener('load', equalizeAtutyHeaders);
});

jQuery(function ($) {
    // WooCommerce mini-cart trigger
    $('body').on('added_to_cart', function () {
        var cartToggle = document.querySelector('[data-bs-target="#miniCartOffcanvas"]');
        if (cartToggle) {
            cartToggle.click();
        }
    });

    // Product filters accordion
    $(document).ready(function () {
        let $firstHeading = $('.wc-block-product-filters__overlay-content > div').first().find('h3.wp-block-heading');
        $firstHeading.addClass('is-open');
        $firstHeading.next().show();

        $(document).on('click', '.wc-block-product-filters__overlay-content .wp-block-heading', function () {
            let $heading = $(this);
            let $content = $heading.next();
            $content.stop(true, true).slideToggle(300);
            $heading.toggleClass('is-open');
        });

        $('.btn-trigger-filters').click(function () {
            $('button.wc-block-product-filters__open-overlay').trigger('click');
        });

        // Desktop dropdown navigation
        $(document).on('click', '#main-menu-desktop .dropdown-toggle', function (e) {
            if (window.innerWidth >= 992) {
                if (this.href && this.href !== '#' && this.href !== window.location.href) {
                    window.location.href = this.href;
                }
            }
        });

        // Mobile Offcanvas Submenu Accordion
        $(document).on('click', '.home-offcanvas .menu-item-has-children > a', function (e) {
            if (window.innerWidth < 1200) { // Using 1200 as per your breakpoint
                e.preventDefault();
                const $parent = $(this).parent();
                const $subMenu = $(this).next('.sub-menu, .dropdown-menu');

                $parent.toggleClass('is-open');
                $subMenu.stop(true, true).slideToggle(300);
            }
        });

        // Footer Navigation Accordion (Mobile)
        $(document).on('click', '.footer-nav-col .footer-col-title', function () {
            if (window.innerWidth < 768) {
                const $parent = $(this).closest('.footer-nav-col');
                const $list = $parent.find('.footer-nav-list');

                // Optional: close other items
                // $('.footer-nav-col').not($parent).removeClass('is-open').find('.footer-nav-list').slideUp(300);

                $parent.toggleClass('is-open');
                $list.stop(true, true).slideToggle(300);
            }
        });

        // WebGL Rippling Water Cursor Effect
        $('.hover-water-drop-effect').each(function () {
            const container = $(this);
            const img = container.find('img');
            if (img.length) {
                container.css({
                    'background-image': `url(${img.attr('src')})`,
                    'background-size': 'cover',
                    'background-position': 'center'
                });
                img.css('opacity', 0);
                container.ripples({
                    resolution: 512,
                    dropRadius: 20,
                    perturbance: 0.04
                });
            }
        });
    });
});




document.addEventListener('DOMContentLoaded', function () {
    // Find all gallery images
    const galleryImages = document.querySelectorAll('.gallery-lightbox-trigger');
    if (galleryImages.length > 0) {
        // Create lightbox HTML structure
        const lightbox = document.createElement('div');
        lightbox.id = 'custom-lightbox';
        lightbox.innerHTML = `
            <div class="lightbox-overlay"></div>
            <div class="lightbox-content">
                <span class="lightbox-close">&times;</span>
                <span class="lightbox-prev">&#10094;</span>
                <img class="lightbox-img" src="" alt="Popup Image">
                <span class="lightbox-next">&#10095;</span>
            </div>
        `;
        document.body.appendChild(lightbox);

        // Get control elements
        const lightboxImg = lightbox.querySelector('.lightbox-img');
        const closeBtn = lightbox.querySelector('.lightbox-close');
        const prevBtn = lightbox.querySelector('.lightbox-prev');
        const nextBtn = lightbox.querySelector('.lightbox-next');
        const overlay = lightbox.querySelector('.lightbox-overlay');

        let currentIndex = 0;

        // Function to show the image
        function showImage(index) {
            if (index < 0) index = galleryImages.length - 1;
            if (index >= galleryImages.length) index = 0;
            currentIndex = index;

            // Get the original URL from data-full, fallback to src if not available
            const imgSrc = galleryImages[currentIndex].getAttribute('data-full') || galleryImages[currentIndex].src;
            lightboxImg.src = imgSrc;
        }

        // Open lightbox
        function openLightbox(index) {
            showImage(index);
            lightbox.style.display = 'flex';
            document.body.style.overflow = 'hidden'; // Disable page scroll
        }

        // Close lightbox
        function closeLightbox() {
            lightbox.style.display = 'none';
            document.body.style.overflow = ''; // Restore page scroll
        }

        // Attach click events to all thumbnails
        galleryImages.forEach((img, index) => {
            img.addEventListener('click', () => openLightbox(index));
        });

        // Events for control buttons
        closeBtn.addEventListener('click', closeLightbox);
        overlay.addEventListener('click', closeLightbox);
        prevBtn.addEventListener('click', () => showImage(currentIndex - 1));
        nextBtn.addEventListener('click', () => showImage(currentIndex + 1));

        // Keyboard controls (Arrows and Escape)
        document.addEventListener('keydown', (e) => {
            if (lightbox.style.display === 'flex') {
                if (e.key === 'Escape') closeLightbox();
                if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
                if (e.key === 'ArrowRight') showImage(currentIndex + 1);
            }
        });
    }

    // Green line scroll animation
    const greenLineObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
            } else {
                entry.target.classList.remove('is-visible');
            }
        });
    }, { threshold: 0.1 });

    const initGreenLines = () => {
        setTimeout(() => {
            document.querySelectorAll('.header_green_line').forEach(line => {
                greenLineObserver.observe(line);
            });
        }, 150);
    };

    if (document.fonts) {
        document.fonts.ready.then(initGreenLines);
    } else {
        window.addEventListener('load', initGreenLines);
    }
});